module.exports = __webpack_public_path__ + "img/bannerMobile-02.009b0850.png";